import {createSelector} from '@reduxjs/toolkit'
import {RootState} from '../types'

const selectIdnTableState = (state: RootState) => state.idnTable

export const selectIntegratedDeliveryNotes = createSelector(selectIdnTableState, state => state.integratedDeliveryNotes)
